import { z } from "zod";

// Spark Opportunities
export const SparkOpportunitySchema = z.object({
  opportunity_id: z.string(),
  insight_type: z.string().default(""),
  name: z.string().default(""),
  description: z.string().default(""),
  severity: z.string().default("medium"),
  application_id: z.string().default(""),
  cluster_id: z.string().default(""),
  cost_savings_min: z.number().default(0),
  cost_savings_max: z.number().default(0),
  time_savings_min: z.number().default(0),
  time_savings_max: z.number().default(0),
  stage_ids: z.array(z.number()).default([]),
  code_links: z
    .array(
      z.object({
        source_path: z.string().default(""),
        cell_number: z.number().default(0),
        confidence: z.number().default(0),
        original_code: z.string().default(""),
      })
    )
    .default([]),
});

export const SparkOpportunitySummarySchema = z.object({
  total: z.number().default(0),
  by_severity: z.record(z.string(), z.number()).default({}),
  by_type: z.record(z.string(), z.number()).default({}),
  total_time_savings_min: z.number().default(0),
  total_time_savings_max: z.number().default(0),
  total_cost_savings_min: z.number().default(0),
  total_cost_savings_max: z.number().default(0),
});

export const SparkOpportunitiesResponseSchema = z.object({
  opportunities: z.array(SparkOpportunitySchema).default([]),
  summary: SparkOpportunitySummarySchema.default({}),
});

export type SparkOpportunity = z.infer<typeof SparkOpportunitySchema>;
export type SparkOpportunitiesResponse = z.infer<typeof SparkOpportunitiesResponseSchema>;

// Individual Spark task schemas
export const SparkTaskDetailSchema = z.object({
  task_id: z.number(),
  stage_id: z.number(),
  index: z.number().default(0),
  attempt_id: z.number().default(0),
  executor_id: z.string().nullable().optional(),
  executor_run_time: z.number().default(0),
  duration_ms: z.number().default(0),
  jvm_gc_time: z.number().default(0),
  memory_bytes_spilled: z.number().default(0),
  disk_bytes_spilled: z.number().default(0),
  shuffle_read_bytes: z.number().default(0),
  shuffle_write_bytes: z.number().default(0),
  launch_time: z.number().nullable().optional(),
  finish_time: z.number().nullable().optional(),
  failed: z.boolean().default(false),
  killed: z.boolean().default(false),
  speculative: z.boolean().default(false),
});

export const SparkTasksPaginatedResponseSchema = z.object({
  items: z.array(SparkTaskDetailSchema).default([]),
  total_count: z.number().default(0),
  page: z.number().default(1),
  page_size: z.number().default(20),
  total_pages: z.number().default(1),
});

export type SparkTaskDetail = z.infer<typeof SparkTaskDetailSchema>;
export type SparkTasksPaginatedResponse = z.infer<typeof SparkTasksPaginatedResponseSchema>;
